@if (ready | async) {
  <filter-table
    [title]="title"
    [data]="data"
    [relatedToType]="'Project'"
    [canAddDeal]="true"
    [savedView]="savedView"
    [queryFilters]="queryFilters"
    [fieldDefs]="fieldDefs"
    [displayColumns]="displayColumns"
    [dataset]="results_dataset"
    [pagination]="results_pagination"
    [sortState]="sortState"
    [allowCsvExport]="true"
    (pageEvent)="page($event)"
    (sortEvent)="sort($event)"
    (filterEvent)="filter($event)"
    (searchEvent)="search($event)"
    (updateEvent)="update($event)"
    (exportCsvEvent)="exportCsv()"
    (dealAdded)="onDealAdded($event)"
    [tableIsLoading]="isLoading"
  ></filter-table>
}
